import React, { useState, useRef, useEffect } from "react";

import AddressCheckboxList from "../components/AddressCheckBoxList.js";
import ItineraryCheckboxList from "../components/ItineraryCheckBoxList.js";
import MapsWithRoute from "../components/MapWithRoute.js";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import logger from "../services/Logger.js";
import { IS_TEST } from "../consts.js";
import LocationSearchInput from "../components/LocationSearchInput.js";
const MapRoute = () => {
  // passing parameters into the page
  const location = useLocation();
  const selectedAddresses = useRef();
  const navigate = useNavigate();
  const [origin, setOrigin] = useState(IS_TEST ? "9414 N Lamar Blvd, Austin, TX 78753" : "");
  const [destination] = useState(IS_TEST ? "13301 N Hwy 183, Austin, TX 78750" : "");
  const [timeOnProperty, setTimeOnProperty] = useState(15);
  const [locations] = useState(
    location.state
      ? location.state
      : [
          {
            placeId: "ChIJ3dmfOO8yW4YRU7gv3dnr7BE",
            locationAddress: "10518 Glass Mountain Trail, Austin, TX 78750",
            latLng: { lat: 30.4449992, lng: -97.81325199999999 },
          },
          {
            placeId: "ChIJT64hH-YyW4YRRR7TkUGNRLs",
            locationAddress: "10503 Weller Drive Austin Tx 78750",
            latLng: { lat: 30.4433882, lng: -97.8111205 },
          },
          {
            placeId: "ChIJWdURkYwyW4YRSVqboHHq_ns",
            locationAddress: "11704 Tanglebriar Trail, Austin, TX 78750",
            latLng: { lat: 30.4563892, lng: -97.82228479999999 },
          },
          {
            placeId: "ChIJvf0FIFEtW4YR-PkotfZKLjY",
            locationAddress: "10500 Nicolet Way, Austin, TX 78717",
            latLng: { lat: 30.4861976, lng: -97.7932484 },
          },
          {
            placeId: "ChIJR4bc_mHJRIYRpFEbwA1QzUE",
            locationAddress: "9414 N Lamar Blvd, Austin, TX 78753",
            latLng: { lat: 30.3647586, lng: -97.6979727 },
            isConstraint: true,
          },
          {
            placeId: "EiYxMzMwMSBOIEh3eSAxODMsIEF1c3RpbiwgVFggNzg3NTAsIFVTQSIxEi8KFAoSCZ3Zd33NMluGEWVUVEvzT55LEPVnKhQKEgnp_DLNXS1bhhFk-4XsUC53QA",
            locationAddress: "13301 N Hwy 183, Austin, TX 78750",
            latLng: { lat: 30.4446319, lng: -97.7866315 },
            isConstraint: true,
          },
        ]
  );
  const [startTime, setStartTime] = useState("2025-02-13T09:00:00");

  const [routes, setRoutes] = useState([]);

  const [waypoints, setWaypoints] = useState([]);

  const handleRoute = (data) => {
    //console.log("These are the routes:", data);
    setRoutes(data);
  };

  useEffect(() => {
    logger.info("Waypoints updated updated:", waypoints);
  }, [waypoints]);

  const onCheckBoxSelectionChange = () => {
    logger.info("onCheckBoxSelectionChange");
    const response = selectedAddresses.current.getCheckedAddresses();
    logger.info("response - ", response);
    const subset = locations.reduce((result, item) => {
      if (response.includes(item.locationAddress)) {
        // logger.info("item included - ", item);
        result.push(item);
      }
      logger.info("return result - ", result);
      return result;
    }, []);

    logger.info("These are the checked addresses (subset) - ", subset);
    setWaypoints(subset);
  };

  const navigateToScheduleTour = () => {
    navigate("/Tour");
  };

  return (
    <>
      <h1>Map route Page</h1>
      <div>
        <div>
          Starting point:
          <LocationSearchInput onSelect={setOrigin} />
          Depart time from starting point:
          <input
            type="datetime-local"
            id="commuteTime"
            name="commuteTime"
            min="09:00"
            max="18:00"
            value={startTime}
            onChange={(e) => setStartTime(e.target.value)}
          />
          Default time on property:
          <input type="number" value={timeOnProperty} onChange={(e) => setTimeOnProperty(e.target.value)} />
        </div>
      </div>
      <div>{locations && <AddressCheckboxList items={locations} ref={selectedAddresses} checkboxChange={onCheckBoxSelectionChange} />}</div>

      <div>
        <MapsWithRoute locations={waypoints} origin={origin} destination={destination} onRouteCalculated={handleRoute}></MapsWithRoute>
      </div>

      <div>
        <ItineraryCheckboxList startTime={startTime} items={routes} timeOnProperty={timeOnProperty}></ItineraryCheckboxList>
      </div>
      <button onClick={navigateToScheduleTour}>Schedule tour</button>
    </>
  );
};

export default MapRoute;
